import React from "react"
import { Box, Button, Text } from "@chakra-ui/react"

import Dropdown from "@app/components/Dropdown"
import { ProductStockSiblingDropdownItem } from "@app/components/Product/Stock/ProductStockSiblingDropdownItem"
import Icon from "@app/components/Icon"

type Props = {
  siblings: Array<GatsbyTypes.SanityProduct>
  activeSibling: GatsbyTypes.SanityProduct | null
  setSelectedSiblingHandle: (handle: string) => void
}

export const ProductStockSiblingDropdown: React.FC<Props> = React.memo(({ siblings, activeSibling, setSelectedSiblingHandle }) => (
  <Box>
    <Text variant="text14" mb={2}>
      Selection
    </Text>
    <Dropdown
      dropdownProps={{
        zIndex: 300,
        maxH: "280px",
        overflowX: "unset",
        overflowY: "auto",
      }}
      renderButton={(open: boolean) => (
        <Button
          variant="dropdown"
          w="100%"
          borderBottomLeftRadius={open ? 0 : "21.6px"}
          borderBottomRightRadius={open ? 0 : "21.6px"}
          borderBottomColor={open ? "transparent" : "brand.darkBlue"}
          _active={{
            bgColor: open ? "brand.white" : "brand.darkBlue",
          }}
          _hover={{
            color: open ? "brand.darkBlue" : "brand.white",
            bgColor: open ? "brand.white" : "brand.darkBlue",
          }}
        >
          {activeSibling?.colorTitle}
          <Icon name="chevronDownDropdown" width="10px" height="6px" />
        </Button>
      )}
      renderDropdown={onItemClick => (
        <>
          {siblings?.map((sibling, index) => (
            <ProductStockSiblingDropdownItem
              key={index}
              activeSibling={activeSibling}
              onClose={onItemClick}
              setSelectedSiblingHandle={setSelectedSiblingHandle}
              sibling={sibling}
            />
          ))}
        </>
      )}
    />
  </Box>
))
